/**
 * Sentry Environment Configuration - Staging
 * 
 * This file contains the Sentry configuration for the staging environment.
 */

const environment = 'staging';

const dsn = 'https://f886c6b71b3f262a558887b72e6fc280@o4510606227603456.ingest.de.sentry.io/4510730735255632';

// Export for backward compatibility
export default {
  environment,
  dsn,
};

export { environment, dsn };
